import { render } from "./SaturdayChallengeButton.vue?vue&type=template&id=03d1094c&scoped=true"
import script from "./SaturdayChallengeButton.vue?vue&type=script&lang=js"
export * from "./SaturdayChallengeButton.vue?vue&type=script&lang=js"

import "./SaturdayChallengeButton.vue?vue&type=style&index=0&id=03d1094c&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SaturdayChallengeButton.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_3bc203ad%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fseller_reward%2FSaturdayChallengeButton.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d1094c"]])

export default __exports__